import React from 'react';

import { FormattableAddress, formatAddress } from 'shared';

import { TextCell, TextCellProps } from '../CellPatterns';

export type AddressCellAddress = Partial<FormattableAddress>;

interface Props extends Pick<TextCellProps, 'align' | 'href'> {
  address: AddressCellAddress | null | undefined;
  /** When false, line2 is omitted from the primary line. Default true. */
  includeLine2?: boolean;
}

const AddressCell: React.FC<Props> = ({ address, href, align, includeLine2 = true }) => {
  if (!address) {
    return <TextCell value={null} href={href} align={align} />;
  }

  const primaryLine = formatAddress(address, {
    line1: true,
    line2: includeLine2,
    city: false,
    region: false,
    postal_code: false
  });

  const secondaryLine = formatAddress(address, {
    line1: false,
    line2: false,
    city: true,
    region: true,
    postal_code: true
  });

  return <TextCell value={primaryLine || null} supportingText={secondaryLine || null} href={href} align={align} />;
};

export default AddressCell;
